import { render, staticRenderFns } from "./XmDialog.vue?vue&type=template&id=5be05ec2&scoped=true"
import script from "./XmDialog.vue?vue&type=script&lang=js"
export * from "./XmDialog.vue?vue&type=script&lang=js"
import style0 from "./XmDialog.vue?vue&type=style&index=0&id=5be05ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be05ec2",
  null
  
)

export default component.exports